var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "table",
        {
          staticClass: "table table-striped table-bordered w-100 tabla-default",
        },
        [
          _vm._m(0),
          _vm._v(" "),
          _c(
            "tbody",
            _vm._l(_vm.interacciones, function (interaccion) {
              return _c("tr", [
                _c("td", [_vm._v(_vm._s(interaccion.estado))]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(interaccion.canal))]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(interaccion.medio))]),
                _vm._v(" "),
                _c("td", [_vm._v(_vm._s(interaccion.ultima_actualizacion))]),
                _vm._v(" "),
                _c("td", [
                  _c("div", { staticClass: "btn-group" }, [
                    _c(
                      "button",
                      {
                        staticClass: "btn btn-primary dropdown-toggle",
                        attrs: { "data-toggle": "dropdown" },
                      },
                      [_vm._v(" Opciones")]
                    ),
                    _vm._v(" "),
                    _c("ul", { staticClass: "dropdown-menu" }, [
                      _c("li", [
                        _c(
                          "a",
                          {
                            staticClass: "dropdown-item",
                            on: {
                              click: function ($event) {
                                $event.preventDefault()
                                return _vm.mostrarModalHistorial(
                                  interaccion.id_inter_global
                                )
                              },
                            },
                          },
                          [_vm._v(" Ver Historial")]
                        ),
                      ]),
                    ]),
                  ]),
                ]),
              ])
            }),
            0
          ),
        ]
      ),
      _vm._v(" "),
      _c("historial-modal-component", { ref: "ModalHistorial" }),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Estado")]),
        _vm._v(" "),
        _c("th", [_vm._v("Canal")]),
        _vm._v(" "),
        _c("th", [_vm._v("Medio")]),
        _vm._v(" "),
        _c("th", [_vm._v("Última Actualización")]),
        _vm._v(" "),
        _c("th", [_vm._v("Opciones")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }